export default __webpack_public_path__ + "images/persone1.jpg";